import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useTheme } from '@/contexts/ThemeContext';
import {
  initAnalytics,
  setAnalyticsLanguage,
  setAnalyticsTheme,
  trackPageView
} from '@/lib/analytics';

const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const { actualTheme } = useTheme();

  useEffect(() => {
    void initAnalytics();
  }, []);

  useEffect(() => {
    setAnalyticsLanguage(language);
  }, [language]);

  useEffect(() => {
    setAnalyticsTheme(actualTheme);
  }, [actualTheme]);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    void initAnalytics().then(() => {
      trackPageView(path);
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsRouteTracker;
